import { Component, OnInit, TemplateRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { PM_V2_Service } from '../../../Service/PM_V2/PM_V2.service';
import {
  PM_V2_Assignment_Interface,
  PM_V2_Assignment_Item_Interface
} from '../../../Interface/PM_V2_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-pm-v2-assignment-detail',
  templateUrl: './PM_V2_AssignmentDetail.component.html',
  styleUrls: ['./PM_V2_AssignmentDetail.component.css']
})
export class PM_V2_AssignmentDetailComponent implements OnInit {

  ID: number = 0;
  Model: PM_V2_Assignment_Interface | null = null;
  Items: PM_V2_Assignment_Item_Interface[] = [];
  Procssing: boolean = false;


  constructor(
    private PM_V2_Service: PM_V2_Service,
    private route: ActivatedRoute,
    private Alertify_Service: AlertifyService,
    private modalService: BsModalService,
    private Nav_Service: NavService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.Nav_Service.CheckValidPage(2239).subscribe(
      data => {
        this.ID = Number(this.route.snapshot.paramMap.get('id') || 0);

        if (this.ID <= 0) {
          this.router.navigate(['/pm-v2/assignment']);
          return;
        }

        this.ReadData();
      }
      , error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )

  }

  ReadData() {
    this.Procssing = true;

    this.PM_V2_Service.GetAssignmentSingle(this.ID).subscribe(
      data => {
        this.Model = data.model;
        this.Items = data.items || [];
        this.Procssing = false;
      },
      error => this.HandleError(error)
    );
  }

  Execute(item: PM_V2_Assignment_Item_Interface) {
    this.router.navigate(
      ['/pm-v2/execution/add', item.id],
      {
        queryParams: {
          returnUrl: this.router.url,
          title: item.Title_Item || '',
          due: item.Next_PM_Date || '',
          type: item.Type_Item || ''
        }
      }
    );
  }

  History(item: PM_V2_Assignment_Item_Interface) {
    this.router.navigate(['/pm-v2/execution/history', item.id]);
  }


  Back() {
    this.router.navigate(['/pm-v2/assignment']);
  }

  StatusClass(status?: string): string {
    switch (status) {
      case 'Overdue': return 'badge-danger';
      case 'Due': return 'badge-warning';
      case 'Warning': return 'badge-warning';
      case 'Normal': return 'badge-success';
      default: return 'badge-secondary';
    }
  }

  StatusTitle(status?: string): string {
    switch (status) {
      case 'Overdue': return 'عقب‌افتاده';
      case 'Due': return 'سررسید';
      case 'Warning': return 'هشدار';
      case 'Normal': return 'عادی';
      case 'NoDate': return 'بدون تاریخ';
      default: return status || '-';
    }
  }


  Delete(item: any) {
    item.DeletingProccess = true
    this.modalRef_Delete.hide()
    this.PM_V2_Service.DeleteAssignmentItem(item.id).subscribe(
      data => {
        this.Alertify_Service.SuccessMessage('وضعیت آیتم تغییر کرد.');
        this.ReadData();
      },
      error => this.HandleError(error)
    );
  }

  Data_Seleted_Delete: any
  modalRef_Delete: any;
  openModal(template: TemplateRef<any>, Record: any) {
    this.Data_Seleted_Delete = Record
    this.modalRef_Delete = this.modalService.show(template);
  }

  private HandleError(error: any) {
    this.Procssing = false;


    this.Alertify_Service.ErrorMessage('خطا در دریافت اطلاعات.');
  }
}
